export default {
    state: {
        settings: null,
        slideImages: [],
    },
    mutations: {
        SET_STORE_SETTINGS(state, payload){
            state.slideImages = payload.data.slide_images;
            delete payload.data.slide_images;
            state.settings = payload.data;
        },
        UPDATE_STORE_SETTINGS(state, data){
            Object.assign(state.settings, data);
        },
        ADD_SLIDE_IMAGE(state, image){
            state.slideImages.push(image);
        },
        DELETE_SLIDE_IMAGE(state, id){
            state.slideImages = state.slideImages.filter(slide=>slide.id !== id);
        }
    },
    actions: {
        getStoreSettings({commit}, payload){
            let url = '/store/settings';
            return new Promise((resolve, reject)=>{
                return window.axios.get(url).then(response=>{
                    commit('SET_STORE_SETTINGS', response.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            });
        },
        updateStoreSettings({commit}, payload){
            let url = '/store/settings';
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data).then(response=>{
                    commit('UPDATE_STORE_SETTINGS', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },

        uploadSlideImage({commit}, payload){
            let url = `/store/slide-images`;
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response)=>{
                    commit('ADD_SLIDE_IMAGE', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        deleteSlideImage({commit}, payload){
            let url = 'store/slide-images/' + payload.data.id;
            return new Promise((resolve, reject)=>{
                window.axios.delete(url).then((response)=>{
                    commit('DELETE_SLIDE_IMAGE', payload.data.id);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
    }
}